module.exports = __webpack_public_path__ + "static/media/promotion.ce30b5cc.svg";